export const flagApiIdentifier = '3yPSqHWPatn9EckWwdM2sv';
